import React, { FC } from "react";
import { motion } from "framer-motion";
import { createPortal } from "react-dom";
import { IoMdClose } from "react-icons/io";
import Overlay from "../../checkEligibilty/components/modals/Overlay";
import { ContainerVariants } from "../../checkEligibilty/components/modals/variant";
import { Form, Formik } from "formik";
import { object, string } from "yup";
import InputField from "../../components/formik fields/InputField";
import useNavigateToFibiVoice from "../../../../hooks/useNavigateToFibiVoice";
import { Link } from "react-router-dom";
import { useReserveFibiFreeTrial } from "../../../../hooks/utils/useUtils";
import { toast } from "react-toastify";
import storage from "../../../../utils/storage";
import { hasFibiFreeTrialText } from "./data";

interface Props {
  onClose: () => void;
}

const ReserveFreeTrialModal: FC<Props> = ({ onClose }) => {
  const { url } = useNavigateToFibiVoice();
  const { mutate, isLoading } = useReserveFibiFreeTrial();

  const onSubmit = (values: { email: string }) => {
    mutate(values, {
      onSuccess: () => {
        toast.success("Free trial reserved successfully!");
        storage.set(hasFibiFreeTrialText, true);
        onClose();
      },
    });
  };

  return createPortal(
    <Overlay onClose={onClose}>
      <motion.div
        onClick={(e) => e.stopPropagation()}
        variants={ContainerVariants}
        className=" w-[90vw] sm:w-[600px] h-max overflow-y-auto bg-white rounded-xl sm:px-6"
      >
        <div className="h-full bg-gray-50 py-10 px-4 relative">
          <div className="w-full mx-auto">
            {/* Header */}
            <div className="mb-8">
              {/* Close Button */}
              <IoMdClose
                onClick={onClose}
                className="cursor-pointer absolute right-3 top-2 bg-white"
                size={24}
              />
              {/* Main Title */}
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center">
                Your Free Trial is Waiting
              </h2>
              {/* Subtitle */}
              <p className="mt-3 text-gray-600 text-center max-w-lg mx-auto">
                Reserve your spot now and enjoy full access to our interview
                trainer for free. No strings attached — just better preparation.
              </p>
            </div>

            <Formik
              initialValues={{
                email: "",
              }}
              onSubmit={onSubmit}
              validationSchema={object({
                email: string()
                  .email("Invalid email address")
                  .required("Email is required"),
              })}
            >
              <Form>
                <InputField
                  name="email"
                  label="Email"
                  placeholder="Enter your email..."
                />

                {/* Action Button */}
                <div className="mt-6 flex justify-center">
                  <button
                    type="submit"
                    className={`w-full sm:w-auto px-6 py-3 bg-primaryColor hover:bg-primaryColor/80 text-white font-semibold rounded-lg transition-colors duration-300 ${
                      isLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={isLoading}
                  >
                    Reserve My Free Trial
                  </button>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-500 my-1">
                  <div className="w-full h-[1px] bg-gray-300"></div>
                  or
                  <div className="w-full h-[1px] bg-gray-300"></div>
                </div>

                {/* Small Text Below Button */}
                <div className="w-full flex items-center justify-center">
                  <Link
                    to={url}
                    onClick={onClose}
                    className="text-center text-sm text-primaryColor underline"
                  >
                    Get your free trial now!
                  </Link>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </motion.div>
    </Overlay>,
    document.body
  );
};

export default ReserveFreeTrialModal;
